<template>
  <span id="start">
    <v-container fluid>
      <v-row class="new-publication">
        <v-card target="_blank" elevation="0.5" max-width="100%">
          <v-card-title>
            <h1 class="title">New Publication</h1>
          </v-card-title>
          <v-row>
            <v-col cols="12">
              <v-text-field class="textarea" label="Title" v-model.lazy="ntitle" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field class="textarea" label="Journal" v-model.lazy="njournal" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field class="textarea" label="Year" v-model.number="nyear" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field class="textarea" label="link" v-model.lazy="nlink" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field class="textarea" label="order" v-model.number="norder" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                class="textarea"
                label="type: preprint, peer, conference, editorials, bookChapters"
                v-model.number="ntype"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input class="textarea" label="Image" v-model.lazy="nimage" />
            </v-col>
            <v-col cols="12">
              <v-textarea
                row="1"
                dense
                label="Complete Text"
                class="textarea"
                v-model.lazy="ntext"
              />
            </v-col>
            <v-col cols="12">
              <v-btn
                @click="create(ntext, ntitle, njournal, nyear, nlink, norder, ntype, nimage)"
              >Create</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-row>
      <template v-if="loadingPublications">
        <span>
          <loading-progress
            :progress="10"
            indeterminate
            size="64"
            shape="semicircle"
            rotate
            hide-background
            fillDuration="3"
            rotationDuration="0.5"
          />
        </span>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="12">
            <h1>Edit Content</h1>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-switch :disabled="editorial||book||conf||peer" v-model="preprint" label="Preprints"></v-switch>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-switch :disabled="editorial||book||conf||preprint" v-model="peer" label="Peer Reviewed"></v-switch>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-switch :disabled="peer||book||conf||preprint" v-model="editorial" label="Editorial"></v-switch>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-switch :disabled="peer||book||editorial||preprint" v-model="conf" label="Conference"></v-switch>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-switch :disabled="peer||conf||editorial||preprint" v-model="book" label="Book Chapters"></v-switch>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <v-btn :disabled="!peer&&!book&&!conf&&!preprint&&!editorial" @click="correctNumbering(preprint?'preprint':peer?'peer':conf?'conference':book?'bookChapters':editorial?'editorials':null)">Correct Numbering</v-btn>
          </v-col>
          <v-col class="d-flex" cols="12">
            <v-select
              v-model="id"
              :items="getType(preprint?'preprint':peer?'peer':conf?'conference':book?'bookChapters':editorial?'editorials':null)"
              item-text="order"
              item-value="id"
              label="Publications to edit"
              filled
              v-on:change="updateItem"
            ></v-select>
          </v-col>
        </v-row>

        <v-row v-if="id">
          <v-col cols="12">
            <v-text-field class="textarea" label="Title" v-model.lazy="item.title" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="textarea" label="Journal" v-model.lazy="item.journal" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="textarea" label="Year" v-model.number="item.year" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="textarea" label="Link" v-model.lazy="item.link" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="textarea" label="Order" v-model.number="item.order" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="textarea" label="type: preprint, peer, conference, editorials, bookChapters" v-model.lazy="item.type" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="textarea" label="Cover link" v-model.lazy="item.cover" />
          </v-col>

          <v-col cols="12" md="6">
            <v-img class="image" contain :src="item.img"></v-img>
          </v-col>
          <v-col  cols="12" md="3">
            <v-file-input v-model="newFile" label="New photo" ></v-file-input>
          </v-col>

          <v-col cols="12">
            <v-textarea row="1" label="Text" dense class="textarea" v-model.lazy="item.text" />
          </v-col>
          <v-col cols="6">
            <v-btn @click="saveData()">Update</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="red" @click="deleteData()">Delete</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-container>
  </span>
</template>


<script>
import { mapState } from "vuex";
import { uploadPhoto } from "@/helpers/storage.js";

export default {
  name: "PublicationsEdit",
  data() {
    return {
      total: 0,
      editorial: false,
      book: false,
      peer: false,
      conf: false,
      preprint: false,
      id: null,
      item: {},
      newFile: null,
      loading: true,
      ntitle: null,
      nyear: null,
      nlink: "",
      norder: null,
      njournal: null,
      ntype: null,
      ntext: null,
      nimage: null
    };
  },
  methods: {
    correctNumbering: function(type){
      let pubs = this.publications.filter(doc => doc["type"] == type);
      let biggest = pubs[0].order
      let _this = this;
      pubs.forEach( function(element,idx){
        if(element.order!=biggest-idx){
          element.order = biggest-idx
          
          _this.$store
            .dispatch("updatePublication", element)
            .then(() => (console.log("Updated!", element.id, idx)))
            .catch(() => alert("Error!", element.id, idx));
          
        }
      });
    },
    getType: function(type) {
      //console.log(this.publications.filter(doc => doc["type"] == type))
      return this.publications.filter(doc => doc["type"] == type);
      
    },
    getYear: function(year) {
      return this.getType("peer").filter(doc => doc["year"] == year);
    },
    getCount: function() {
      return this.getType("peer").length;
    },
    getIndex: function() {
      return this.total;
    },
    updateItem() {
      this.item = this.publications.find(val => val.id === this.id);
    },
    saveData() {
      this.loading = true;
      if(this.newFile!=null) this.newFileMet();
      if (this.id)
        this.$store
          .dispatch("updatePublication", this.item)
          .then(() => ((this.loading = false), alert("Updated!")))
          .catch(() => alert("Error! Try again later"));
    },
    deleteData(){
      if (this.id)
        this.$store
          .dispatch("deletePublications", this.item)
          .then(() => ((this.loading = false), alert("Deleted!")))
          .catch(() => alert("Error! Try again later"));
    },
    create(text, title, journal, year, link, order, type, img) {
      if(!text||!title||!journal||!year||!order||!type){
        alert("You are missing a field!")
        return
      }
      this.loading = true;
      const newItem = {
        text: text,
        title: title,
        journal: journal,
        year: year,
        link: link,
        order: order,
        type: type,
        img: ""
      };
      let updatedItem = {};
      Object.assign(updatedItem, newItem);
      delete updatedItem.img;
      this.$store.dispatch("addPublications", updatedItem).then(id => {
        alert("New Publication added")
        if(img!=null){
          uploadPhoto("publications", id, img).then(link2 => {
            updatedItem.img = link2;
            updatedItem.id = id;
            this.$store
              .dispatch("updatePublication", updatedItem)
              .then(() => alert("Image added"));
          });
        }
      });
    },
    newFileMet() {
      uploadPhoto("publications", this.item.id, this.newFile).then(link => {
        this.item.img = link;
        this.$store
          .dispatch("updatePublication", this.item)
          .then(() => alert("Photo updated!"));
      });
    }
  },
  mounted() {
    this.total = this.getCount();
    if (!this.publications.length) {
      this.$store.dispatch("cargarPublications");
      this.loading = false;
    }
    if (this.publications.length) {
      this.loading = false;
    }
    //console.log(this.publications.filter(doc => doc["year"] == '2021'))
  },
  computed: mapState(["loadingPublications", "publications"])
};
</script>

<style scoped>
.text {
  text-align: left;
  font-size: 2.4vmin;
  padding-bottom: 0;
  word-break: break-word;
}

.textarea {
  text-align: left;
  font-size: 2.4vmin;
  padding: 24px;
  word-break: break-word;
  max-height: 50%;
}

.new-publication {
  margin-bottom: 2rem;
}

.subtext {
  text-align: left;
  font-size: 1.75vmin;
  word-break: break-word;
}

.title {
  text-align: left;
  font-size: 3.5vmin !important;
  padding-bottom: 0.25rem;
  padding-top: 0.25rem;
  word-break: break-word;
}

.subtitle {
  text-align: left;
  font-size: 2.6vmin !important;
  padding-bottom: 0.25rem;
  padding-top: 0.25rem;
  padding-left: 12px;
  word-break: break-word;
}

.no-margin {
  margin: 0 !important;
}

.hasLink {
  color: #b80b0b !important;
}

.noLink {
  color: black !important;
}

.center {
  align-content: center;
  text-align: center;
}

.imagenes {
  max-height: 80%;
  max-width: 100%;
}

@media only screen and (max-width: 1000px) {
  .imagenes {
    max-height: 200px;
    max-width: 100%;
  }
}

@media only screen and (max-width: 700px) {
  .imagenes {
    max-height: 200px;
    max-width: 250px;
    align-self: center;
    margin: auto;
  }
}
</style>